export default __webpack_public_path__ + "static/media/dogue-de-bordeaux-1047521_640.17b1dc61.jpg";